import { Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import React, { FunctionComponent, useMemo } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { ZustavateTableItem } from '../../utils/useZustavateData'
import { IpGeolocationTooltip } from '../IpGeolocationTooltip/IpGeolocationTooltip'

export interface ZustavateDataTableExpandedProps {
  record: ZustavateTableItem
}

export const getDisposition = (key?: string) => {
  switch (key) {
    case 'vk1':
      return '1+kk / 1+1'
    case 'vk2':
      return '2+kk / 2+1'
    case 'vk3':
      return '3+kk / 3+1'
    case 'vk4':
      return '4+kk / 4+1'
    case 'vk5':
      return '5+kk / 5+1 a více'
    default:
      return '-'
  }
}

const expandedScrollX = { x: 800 }

export const ZustavateDataTableExpanded: FunctionComponent<ZustavateDataTableExpandedProps> =
  ({ record }) => {
    const expandedColumns = useMemo<ColumnsType<ZustavateTableItem>>(
      () => [
        {
          title: 'IP Adresa',
          dataIndex: 'ipAddress',
          width: 130,
          render: (ipAddress: string | undefined) => (
            <IpGeolocationTooltip ipAddress={ipAddress}>
              {ipAddress}
            </IpGeolocationTooltip>
          ),
        },
        {
          title: 'Krok',
          dataIndex: 'step',
          width: 100,
        },
        {
          title: 'Patro',
          dataIndex: 'floor',
          width: 100,
          render: (floor: string | undefined) => floor || '-',
          responsive:
            record.propertyTypeLabel === PROPERTY_TYPES.BUILDING
              ? []
              : undefined,
        },
        {
          title: 'Vlastnictví',
          dataIndex: 'ownership',
          width: 100,
          render: (ownership: string | undefined) => ownership || '-',
        },
        {
          title: 'Stav',
          dataIndex: 'conditionLabel',
          width: 100,
          render: (conditionLabel: string | undefined) => conditionLabel || '-',
        },
        {
          title: 'Dispozice',
          width: 100,
          dataIndex: 'disposition',
          render: getDisposition,
          responsive:
            record.propertyTypeLabel === PROPERTY_TYPES.BUILDING
              ? []
              : undefined,
        },
        {
          title: 'Výměra',
          dataIndex: 'exactArea',
          width: 100,
          render: (exactArea, record) =>
            exactArea ? `${exactArea} m²` : record.floorAreaLabel,
        },
        {
          title: 'Poloha domu',
          dataIndex: 'houseLocation',
          render: (houseLocation: string | undefined) => houseLocation || '-',
          responsive:
            record.propertyTypeLabel === PROPERTY_TYPES.UNIT ? [] : undefined,
        },
        {
          title: 'Balkón',
          dataIndex: 'balconyArea',
          render: (balconyArea: string | undefined) =>
            balconyArea ? `${balconyArea} m²` : 'ne',
          responsive:
            record.propertyTypeLabel === PROPERTY_TYPES.BUILDING
              ? []
              : undefined,
        },
      ],
      [record.propertyTypeLabel]
    )

    return (
      <Table
        rowKey="id"
        size="small"
        columns={expandedColumns}
        dataSource={[record]}
        pagination={false}
        showHeader={true}
        scroll={expandedScrollX}
        className="bg-gray-50 mb-4"
      />
    )
  }
